import { ColorsType } from '../types'

const Palette = {
    brand: {
        primary: '#31173D',
        secondary: '#FFE4D3',
        nightBlack: '#161616',
    },
    uplate: {
        default: '#31173D',
        light: '#DDD9E5',
        accent: '#310048',
    },
    starlight: {
        default: '#FFE4D3',
        light: '#FFF9F4',
        accent: '#4D393E',
    },
    white: '#FFFFFF',
    black: '#000000',
    grey: {
        100: '#161616',
        90: '#262626',
        80: '#393939',
        70: '#525252',
        60: '#6F6F6F',
        50: '#8D8D8D',
        40: '#A8A8A8',
        30: '#C6C6C6',
        20: '#E0E0E0',
        10: '#F4F4F4',
    },
    section: {
        business: {
            default: '#FF6300',
            light: '#FFE0CC',
        },
        entertainment: {
            default: '#EB1320',
            light: '#FBD0D2',
        },
        features: {
            default: '#F49100',
            light: '#FDE9CC',
        },
        news: {
            default: '#4B006E',
            light: '#DBCCE2',
        },
        realestate: {
            default: '#0024A7',
            light: '#CCD3ED',
        },
        sport: {
            default: '#0064FF',
            light: '#CCE0FF',
        },
        world: {
            default: '#A663CC',
            light: '#EDE0F5',
        },
    },
    utility: {
        success: {
            default: '#20BA42',
            light: '#D0F9D9',
            dark: '#034211',
        },
        warning: {
            default: '#EBB018',
            light: '#FFECBD',
            dark: '#663700',
        },
        error: {
            default: '#9D0009',
            light: '#FFC3C7',
            dark: '#420000 ',
        },
    },
} as const

export type TheNightlyPalette = typeof Palette

export type TheNightlyColourMap = ColorsType<TheNightlyPalette>

export const colors: TheNightlyColourMap = {
    brand: Palette.brand.nightBlack,
    section: Palette.brand.secondary,
    background: {
        primary: Palette.brand.nightBlack,
        secondary: Palette.brand.secondary,
    },
    palette: Palette,
    text: {
        primary: Palette.grey[100],
        secondary: Palette.black,
        heading: Palette.grey[100],
    },
    actions: {
        link: {
            default: Palette.grey[100],
            hover: Palette.starlight.accent,
            focus: Palette.starlight.accent,
            active: Palette.starlight.accent,
        },
        button: {
            primary: {
                text: {
                    default: Palette.white,
                    hover: Palette.grey[100],
                    focus: Palette.grey[100],
                    active: Palette.grey[100],
                },
                background: {
                    default: Palette.grey[100],
                    hover: Palette.white,
                    focus: Palette.white,
                    active: Palette.white,
                },
                border: {
                    default: Palette.grey[100],
                    hover: Palette.grey[100],
                    focus: Palette.grey[100],
                    active: Palette.grey[100],
                },
            },
        },
    },
    borders: {
        primary: Palette.brand.primary,
    },
}
